import ExternalLinkTeal from "@assets/images/external-link-teal.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import {
  getTotalNetPriceByLine,
  getTotalNetPriceByLineNewProductGroup,
  showIplanButtonCheck
} from "@saleor/changeOrderDomestic/utils";
import { ItemTab } from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import Checkbox from "@saleor/components/Checkbox";
import DecimalFormat from "@saleor/components/DecimalFormat";
import MyTypography from "@saleor/components/MyTypography";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { BIG_ROW_NUMBER_SET } from "@saleor/components/TablePagination/constants";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import { checkIsCashSaleOrder } from "@saleor/createOrChangeNotRefContract/utils";
import CashSaleForm, {
  CashSaleFormProps
} from "@saleor/createOrder/components/CashSaleForm";
import { DomesticOrderSortField } from "@saleor/createOrderDomestic/urls";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import {
  ContractChangeOrderDomesticQuery,
  IPlanOrderItemStatus,
  ReasonForChangeRequestDateEnum
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import { renderCollection } from "@saleor/misc";
import { ListProps, SortPage } from "@saleor/types";
import { PROD_CATEG_1, SALE_CATEG_1 } from "@saleor/utils/constants";
import { isKO1KO9 } from "@saleor/utils/data/convertUnit";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedNumber, useIntl } from "react-intl";

import useStyles from "./styles";

interface ICurrentData {
  allowChangeInquiryMethod?: boolean;
  isNewAddItem?: boolean;
  id?: string;
  comfirmQty?: string;
  contractItemNo?: string;
  contractNo?: string;
  deliveryQty?: string;
  deliveryStatus?: string;
  itemCategory?: string;
  itemNo?: string;
  itemQty?: string;
  quantity?: string;
  material?: string;
  materialDesc?: string;
  materialGroup1?: string;
  orderQty?: string;
  paymentTerm?: string;
  paymentTermDescTh?: string;
  plant?: string;
  poNumber?: string;
  prdHierachy?: string;
  requestedDate?: string;
  routeId?: string;
  routeName?: string;
  saleQtyDivision?: string;
  saleQtyFactor?: string;
  saleText1Th?: string;
  salesUnit?: string;
  shippingPoint?: string;
  deliveryTolUnlimited?: boolean;
  weightPerUnit?: string;
  rootUnit?: string;
  errorQuantity?: boolean;
  errorDate?: string | boolean;
  externalCommentsToCustomer?: string;
  shippingMark?: string;
  internalCommentsToLogistic?: string;
  internalCommentsToWarehouse?: string;
  productInformation?: string;
  billTo?: string;
  requestDate?: string;
  route?: string;
  shipTo?: string;
  status?: string;
  statusCancel?: string;
  isSplit?: boolean;
  hasSplit?: boolean;
  flagR5?: boolean;
  requestDateChangeReason?: string;
  originalRequestDate?: string;
  confirmedDate?: string;
  poNo?: string;
  poDate?: string;
  netWeightTon?: string;
  weightUnitTon?: string;
  weightUnit?: string;
  pricePerUnit?: string;
  prNo?: string;
  prItem?: string;
  poSubcontract?: string;
  itemStatusEnDisplayText?: string;
  underDeliveryTol?: string;
  overDeliveryTol?: string;
  atp?: string;
  atpDetails?: string;
  block?: string;
  run?: string;
  paperMachine?: string;
  itemStatusEn?: IPlanOrderItemStatus;
  assignQuantity?: string;
  originQuantity?: string;
  remainWeight?: number;
}

export interface ItemDetailsTabProps
  extends ListProps,
    SortPage<DomesticOrderSortField> {
  currentData: ICurrentData[];
  dataOrder: ContractChangeOrderDomesticQuery["changeOrder"];
  listLineOrder?: any[];
  setListLineOrder?: (value) => void;
  loading?: boolean;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  onNextLastPage?: () => void;
  onPreviousFirstPage?: () => void;
  onUpdateListSettings?: (key, value) => void;
  settings?: ListProps["settings"];
  activeTab?: ItemTab;
  setActiveTab?: (value: ItemTab) => void;
  cashSaleFormProps?: CashSaleFormProps;
}

const tabList = [
  {
    id: "order-information-tab",
    code: ItemTab.tabA,
    title: "ข้อมูลสั่งซื้อ",
    index: "z4",
    first: true
  },
  {
    id: "iplan-tab",
    code: ItemTab.tabB,
    title: "iPlan Details",
    index: "z3",
    first: false
  },
  {
    id: "additional-tab",
    code: ItemTab.tabC,
    title: "Additional Data",
    index: "z2",
    first: false
  },
  {
    id: "cash-sale-tab",
    code: ItemTab.tabD,
    title: "Cash Sale",
    index: "z1",
    first: false
  }
];

const ItemDetailsTab: React.FC<ItemDetailsTabProps> = props => {
  const {
    dataOrder,
    currentData,
    loading,
    hasNextPage,
    hasPreviousPage,
    onNextPage,
    onPreviousPage,
    onNextLastPage,
    onPreviousFirstPage,
    onUpdateListSettings,
    settings,
    sort,
    onSort,
    setActiveTab,
    activeTab,
    cashSaleFormProps
  } = props;
  const [{ fullScreen }] = useAppState();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [reRender, setReRender] = useState<boolean>(false);

  const classes = useStyles({ activeTab });
  const intl = useIntl();
  const isCashSaleOrder = checkIsCashSaleOrder(dataOrder?.orderType);

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  const mapRequestDateChangeReason = requestDateChangeReason => {
    if (requestDateChangeReason === ReasonForChangeRequestDateEnum.C3) {
      return "C3-Logistics";
    } else if (requestDateChangeReason === ReasonForChangeRequestDateEnum.C4) {
      return "C4-Customer";
    } else if (
      requestDateChangeReason === ReasonForChangeRequestDateEnum.X ||
      !requestDateChangeReason
    ) {
      return "None";
    } else {
      return "None";
    }
  };

  const showIplanButton = showIplanButtonCheck(currentData);

  const renderCellHeadA = (
    <>
      <TableCellHeader className={classes.colA0} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Original Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA1} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Request Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA2} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Reason for Change Request Date"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA3} rowSpan={2}>
        <MyTypography variant={"subtitle3"} className={classes.textConfirmDate}>
          {intl.formatMessage({ defaultMessage: "Confirm Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA4, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA5, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA6, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA7, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA8}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Plant" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader
        className={classNames(classes.colA22, classes.noBorderRight)}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Assign Qty." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA23, classes.noBorderLeft)}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader
        className={classes.colA9}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA10}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคารวมสุทธิ" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA11}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA12} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "เงื่อนไขการชำระเงิน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA13}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Cat." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA14}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Shipping Point" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA15}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA16} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "วันที่ออก PO" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA17} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No." })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader className={classes.colA14} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PR No." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA4} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PR Item" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader className={classes.colA17} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No." })}{" "}
          <span className={classes.normalText}>(Outsource)</span>
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA18} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Status" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader colSpan={3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Delivery Tolerance" })}
        </MyTypography>
      </TableCellHeader>
      {showIplanButton ? (
        <TableCellHeader
          className={classes.colA24}
          rowSpan={2}
          textAlign={"center"}
        >
          <MyTypography variant={"subtitle3"}>( P )</MyTypography>
        </TableCellHeader>
      ) : null}
      <TableCellHeader className={classes.colA10} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Product Group" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );
  const renderCellHeadB = (
    <>
      <TableCellHeader className={classes.colB1} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>ATP/CTP</MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB2} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>ATP/CTP Detail</MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Block" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB4} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Run" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB5} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Paper Machine" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );
  const renderCellHeadC = (
    <>
      <TableCellHeader className={classes.colC1} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ship-to Party" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC2} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Warehouse"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "External Comments to Customer"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Remark"
          })}
        </MyTypography>
      </TableCellHeader>
      {/* <TableCellHeader className={classes.colC4} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Logistic"
          })}
        </MyTypography>
      </TableCellHeader> */}
      {/* <TableCellHeader className={classes.colC5} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Production information" })}
        </MyTypography>
      </TableCellHeader> */}
    </>
  );

  const renderCellBodyA = line => (
    <>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.originalRequestDate ? line.originalRequestDate : "-"}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.requestDate
            ? moment(line.requestDate).format("DD/MM/YYYY")
            : ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {mapRequestDateChangeReason(line.requestDateChangeReason)}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line),
            [classes.wrongDate]: line.requestDate !== line.confirmedDate,
            [classes.matchDate]: line.requestDate === line.confirmedDate
          })}
        >
          {line?.confirmedDate
            ? moment(line?.confirmedDate).format("DD/MM/YYYY")
            : ""}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderRight}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {!!line?.itemQty && (
            <FormattedNumber
              value={line.itemQty}
              {...(SALE_CATEG_1(line?.salesUnit)
                ? { minimumFractionDigits: 3, maximumFractionDigits: 3 }
                : {})}
            />
          )}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.salesUnit}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderRight}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.netWeightTon}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.weightUnitTon}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.plant}
        </MyTypography>
      </TableCell>

      <TableCell align={"center"} className={classes.noBorderRight}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          <FormattedNumber
            value={
              (isKO1KO9(line.materialGroup1)
                ? line?.assignQuantity
                : line?.comfirmQty) ?? 0
            }
          />
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.salesUnit}
        </MyTypography>
      </TableCell>

      <TableCell align={"right"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.pricePerUnit ? (
            <FormattedNumber value={line?.pricePerUnit || 0} />
          ) : (
            ""
          )}
        </MyTypography>
      </TableCell>
      <TableCell align={"right"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          <DecimalFormat
            value={
              isProductCateg1
                ? getTotalNetPriceByLine(line)
                : getTotalNetPriceByLineNewProductGroup(line)
            }
            countDecimal={2}
            isGrayDecimal={false}
          />
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {dataOrder?.currency || ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.paymentTerm}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.itemCategory}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.shippingPoint}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.route
            ? line.route
            : line?.routeId
            ? `${line?.routeId} - ${line?.routeName}`
            : ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.poDate ? moment(line?.poDate).format("DD/MM/YYYY") : ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.poNumber}
        </MyTypography>
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.prNo}
        </MyTypography>
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.prItem}
        </MyTypography>
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.poSubcontract}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.itemStatusEnDisplayText || ""}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classNames(classes.noBorderRight)}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.underDeliveryTol}
        </MyTypography>
      </TableCell>
      <TableCell
        align={"center"}
        className={classNames(classes.noBorderRight, classes.noBorderLeft)}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.overDeliveryTol}
        </MyTypography>
      </TableCell>

      <TableCell
        align={"center"}
        className={classNames(classes.noBorderLeft, classes.cellHeadCheck)}
      >
        <MyTypography variant={"body3"} className={classes.cellFlexCenter}>
          <Checkbox
            disabled
            className={classes.checkBoxDisabled}
            checked={line.deliveryTolUnlimited}
          />
          Unlimited
        </MyTypography>
      </TableCell>
      {showIplanButton ? (
        <TableCell align={"center"} className={classes.cellBtn}>
          <Button
            variant={"contained"}
            color={"secondary"}
            className={classes.btnExternal}
            disabled
          >
            <SVG src={ExternalLinkTeal} />
          </Button>
        </TableCell>
      ) : null}
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.materialGroup1 + `: ` + line?.materialGroup1Desc}
        </MyTypography>
      </TableCell>
    </>
  );
  const renderCellBodyB = line => (
    <>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.atp}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.atpDetails}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.block}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.run}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line?.paperMachine}
        </MyTypography>
      </TableCell>
    </>
  );
  const renderCellBodyC = line => (
    <>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line)
          })}
        >
          {line.shipTo ? line.shipTo : ""}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line),
            [classes.boxBackground]: !isItemDisabled(line)
          })}
        >
          {line.internalCommentsToWarehouse}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line),
            [classes.boxBackground]: !isItemDisabled(line)
          })}
        >
          {line.externalCommentsToCustomer}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line),
            [classes.boxBackground]: !isItemDisabled(line)
          })}
        >
          {line?.shippingMark}
        </MyTypography>
      </TableCell>
      {/* <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line),
            [classes.boxBackground]: !isItemDisabled(line)
          })}
        >
          {line.internalCommentsToLogistic}
        </MyTypography>
      </TableCell>
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(line),
            [classes.boxBackground]: !isItemDisabled(line)
          })}
        >
          {line.productInformation}
        </MyTypography>
      </TableCell> */}
    </>
  );

  useEffect(() => {
    setReRender(prevState => !prevState);
  }, [fullScreen]);

  useEffect(() => {
    setReRender(prevState => !prevState);
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [activeTab]);

  const isItemDisabled = item =>
    item.statusCancel === "Cancel" || item.status === "Delete";

  const isProductCateg1 = currentData.some(item =>
    PROD_CATEG_1(item?.materialGroup1)
  );

  return (
    <div className={classes.root}>
      <div className={classes.topBox}>
        <FullScreenButton />
      </div>
      {/* <div className={classes.tabBox}>
        {renderCollection(tabList, tab => (
          <div
            key={tab.code}
            className={classNames(
              activeTab === tab.code ? classes.zMax : classes[tab.index]
            )}
          >
            <div
              onClick={() => onTabClick(tab.code)}
              className={classNames(
                !tab.first && classes.tabB,
                activeTab === tab.code
                  ? classes.tableTabActive
                  : classes.tableTab
              )}
            >
              <MyTypography
                variant={"body2"}
                className={classNames(
                  activeTab === tab.code
                    ? classes.innerTabActive
                    : classes.innerTab
                )}
              >
                {tab.title}
              </MyTypography>
            </div>
          </div>
        ))}
      </div> */}
      <div className={classes.tabBox}>
        {renderCollection(tabList, tab => {
          if (tab.code === ItemTab.tabB && !isProductCateg1) {
            // Hide tabB when isProductCateg1 is NOT true
            return null;
          }
          if (tab.code === ItemTab.tabD && !isCashSaleOrder) {
            return null;
          }

          return (
            <div
              key={tab.code}
              className={classNames(
                activeTab === tab.code ? classes.zMax : classes[tab.index]
              )}
            >
              <Button
                id={tab.id}
                data-testid={tab.id}
                onClick={() => onTabClick(tab.code)}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    onTabClick(tab.code);
                  }
                }}
                className={classNames(
                  !tab.first && classes.tabB,
                  classes.tableTab,
                  activeTab === tab.code
                    ? classes.tableTabActive
                    : classes.tableTabInactive
                )}
              >
                <MyTypography
                  variant={"body2"}
                  className={classNames(
                    activeTab === tab.code
                      ? classes.innerTabActive
                      : classes.innerTab
                  )}
                >
                  {tab.title}
                </MyTypography>
              </Button>
            </div>
          );
        })}
      </div>

      {[ItemTab.tabA, ItemTab.tabB, ItemTab.tabC].includes(activeTab) ? (
        <>
          <div className={classes.boxTable} ref={containerRef}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCellHeader
                    className={classes.cellFrezze1}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                    direction={
                      sort.sort === DomesticOrderSortField.item_no
                        ? getArrowDirection(sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    onClick={() => onSort(DomesticOrderSortField.item_no)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze2}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Material Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze3}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({
                        defaultMessage: "Material Description."
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  {activeTab === ItemTab.tabA && renderCellHeadA}
                  {activeTab === ItemTab.tabB && renderCellHeadB}
                  {activeTab === ItemTab.tabC && renderCellHeadC}
                </TableRow>
                {activeTab === ItemTab.tabA && (
                  <TableRow>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA19,
                        classes.noBorderRight,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellSize13}
                      >
                        Under (%)
                      </MyTypography>
                    </TableCell>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA20,
                        classes.noBorderRight,
                        classes.noBorderLeft,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellSize13}
                      >
                        Over (%)
                      </MyTypography>
                    </TableCell>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA21,
                        classes.noBorderLeft,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classNames(
                          classes.cellSize13,
                          classes.cellFlexCenter
                        )}
                      >
                        <Checkbox
                          disabled
                          className={classes.checkBoxDisabled}
                          checked={currentData.every(
                            item => item.deliveryTolUnlimited
                          )}
                        />
                        Unlimited
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                )}
              </TableHead>
              <TableBody>
                {currentData
                  .filter(orderItem => orderItem.statusCancel !== "Delete")
                  .map(item => (
                    <TableRow key={item.itemNo}>
                      <TableCell
                        className={classes.cellFrezze1}
                        align={"center"}
                      >
                        <MyTypography
                          align="center"
                          variant={"body3"}
                          className={classNames({
                            [classes.disabledLine]: isItemDisabled(item)
                          })}
                        >
                          {/* item.isSplit ? "-" :  */ item.itemNo}
                        </MyTypography>
                      </TableCell>
                      <TableCell className={classes.cellFrezze2}>
                        <MyTypography
                          variant={"body3"}
                          className={classNames({
                            [classes.disabledLine]: isItemDisabled(item)
                          })}
                        >
                          {item.material}
                        </MyTypography>
                      </TableCell>
                      <TableCell className={classes.cellFrezze3}>
                        <MyTypography
                          variant={"body3"}
                          className={classNames({
                            [classes.disabledLine]: isItemDisabled(item)
                          })}
                        >
                          {item.materialDesc}
                        </MyTypography>
                        {isItemDisabled(item) ? (
                          <MyTypography
                            variant={"caption"}
                            className={classNames({
                              [classes.boxCancel]:
                                item.statusCancel === "Cancel",
                              [classes.boxDelete]:
                                item.statusCancel === "Delete"
                            })}
                          >
                            {item.statusCancel === "Cancel"
                              ? "Cancel 93"
                              : "Delete"}
                          </MyTypography>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      {activeTab === ItemTab.tabA && renderCellBodyA(item)}
                      {activeTab === ItemTab.tabB && renderCellBodyB(item)}
                      {activeTab === ItemTab.tabC && renderCellBodyC(item)}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            {activeTab !== ItemTab.tabB ? (
              <StickyHorizontalScrollBar
                container={containerRef}
                reRender={reRender}
              />
            ) : (
              ""
            )}
          </div>
          <TablePaginationCustom
            hasNextPage={loading || hasNextPage}
            hasPreviousPage={loading || hasPreviousPage}
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            totalCount={currentData.length}
            selectColor="#007E92"
            settings={settings}
            onUpdateListSettings={onUpdateListSettings}
            isBackFistPage
            isNextLastPage
            latestPageItemNumber={currentData.length}
            onNextLastPage={onNextLastPage}
            onPreviousFirstPage={onPreviousFirstPage}
            disabled={loading}
            rowNumberSet={BIG_ROW_NUMBER_SET}
          />
        </>
      ) : activeTab === ItemTab.tabD && cashSaleFormProps ? (
        <CashSaleForm {...cashSaleFormProps} />
      ) : null}
    </div>
  );
};

export default ItemDetailsTab;
